/**
 * Paramedie Gelderse Vallei
 *
 * @author Robuust
 * @author Jurriën Peters <jurrien@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';

/**
 * Controller for comparator.
 */
export default class extends Controller {
  static targets = ['input', 'button', 'col'];

  /**
   * Show button and show or hide selected programs.
   */
  compare(e) {
    this.colTargets.forEach((colTarget) => {
      if (e.params.index === +colTarget.dataset.index) {
        colTarget.classList.toggle('hidden', !e.target.checked);
      }
    });

    this.buttonTarget.classList.toggle('active', this.inputTargets.some((x) => x.checked));
  }
}
